// extracted by mini-css-extract-plugin
module.exports = {"rankings-content":"Rankings_rankings-content__YDgKO","rankings-content-intro":"Rankings_rankings-content-intro__MYUIr"};